import FieldController from "../field.controller";

class SelectFieldSearchable extends FieldController {
  constructor($scope, $q, $translate, $log, $timeout, $document) {
    "ngInject";
    super($scope, $q, $translate, $log, $timeout);
    // Function to handle document click
    this.handleDocumentClick = this.handleDocumentClick.bind(this);

    // Attach the click event listener to the document
    $document.on("click", this.handleDocumentClick);

    // Cleanup: Remove the click event listener when the component is destroyed
    $scope.$on("$destroy", () => {
      $document.off("click", this.handleDocumentClick);
    });
  }

  $onInit() {
    super.$onInit();

    // Angular wasn't always picking up the initial value (if there is one)
    // Therefore, unset and reset the value
    if (this.value) {
      const originalValue = this.value;
      this.value = null; // This will trigger logic conditions again
      this.$timeout(() => {
        // This will trigger the value update
        this.value = originalValue;
      });
    }
  }

  handleDocumentClick(event) {
    // Check if the click target is outside the component
    const el = document.getElementById(
      `field_${this.fieldInstance.id}_response_${this.fieldResponse.id}_list`
    );
    if (el && !el.contains(event.target)) {
      this.$scope.$apply(() => {
        this.$timeout(() => {
          this.dropdown = false;
        });
      });
    }
  }

  getSelectedOptionText() {
    const selectedOption = this.$scope.filteredOptions.find(
      (option) => String(option.id) === String(this.value)
    );
    if (selectedOption) {
      return selectedOption.name;
    }
    return '';
  }
}

export default SelectFieldSearchable;
